<template>
  <a-modal
    v-model="visible"
    :title="title || $t('device_export_title')"
    :maskClosable="false"
    :closable="!formLoading"
    :okText="$t('com_btn_download')"
    :width="600"
    @ok="formSubmit"
    :confirmLoading="formLoading"
    :cancelButtonProps="{
      props: {
        disabled: formLoading,
      },
    }"
    destroyOnClose
    centered
  >
    <a-form-model
      :model="form"
      :rules="rules"
      layout="inline"
      ref="formElement"
      labelAlign="right"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 18 }"
    >
      <!-- 名称 -->
      <a-form-model-item :label="$t('device_export_name')" prop="name" style="width:100%;">
        <a-input
          v-model="form.name"
          :placeholder="$t('device_export_name_placeholder')"
          style="width:100%;"
          suffix=".json"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { exportJSON } from '@/libs/utils';
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    callback: {
      type: Function,
      default: () => {},
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // 新增
      visible: false,

      formLoading: false,

      // device info
      deviceInfo: null,

      form: {
        name: undefined,
      },
      rules: {},
      selectedData: [],

      defaultDownloadName: '',
    };
  },
  methods: {
    // 显示
    show(deviceInfo, selectedData) {
      this.visible = true;
      this.deviceInfo = deviceInfo;
      this.selectedData = selectedData;
      this.defaultDownloadName = `${this.deviceInfo.name}-${this.constructor.filter('formatDate')(
        new Date(),
        'yyyyMMddHHmmss'
      )}`;

      this.form.name = this.defaultDownloadName;
    },

    // 提交
    formSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.formLoading = true;
          const outputData = [];
          this.selectedData.forEach(item => {
            const _temp = {};
            _temp.id = item['id'];
            _temp.key = item['dataSrc'];
            _temp.name = item['name'];
            _temp.rvalue = item['rvalue'] || '';
            _temp.dataUnit = item['dataUnit'] || '';
            _temp.dataSrc = item['dataSrc'] || '';
            _temp.value = item['value'] || '';
            outputData.push(_temp);
          });

          let downloadName = this.form.name;

          // 如果没有填写，使用默认
          if (!downloadName) {
            downloadName = this.defaultDownloadName;
          }

          // 名称末尾不能带.json
          if (!/\.json$/gi.test(this.form.name)) {
            downloadName += '.json';
          }

          const self = this;
          exportJSON(outputData, downloadName, function() {
            setTimeout(function() {
              self.formLoading = false;
              self.visible = false;
            }, 1000);
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.params-preview {
  padding-top: 20px;
}
</style>
